import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// tslint:disable-next-line:max-line-length
import { RenewLicenseDialogComponent } from 'src/app/modules/accounts/view-account/license-details/renew-license-dialog/renew-license-dialog.component';
import { RenewDetailsComponent } from 'src/app/modules/accounts/view-account/license-details/renew-details/renew-details.component';
// tslint:disable-next-line:max-line-length
import { EditLicenseDialogComponent } from 'src/app/modules/accounts/view-account/license-details/edit-license-dialog/edit-license-dialog.component';
import { MessageDisplayModule } from '../../validation-messages-display/message-display.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
    imports: [
        CommonModule,
        MessageDisplayModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule
    ],
    declarations: [
        RenewLicenseDialogComponent,
        EditLicenseDialogComponent,
        RenewDetailsComponent,
    ]
})
export class LicenseModule { }
